import { loadRawEntityDataByQuery } from '@adornis/bh-util/util.js';
import { getDbPluginForScope } from './db-plugins.js';
import { BHPayment } from './entities/BHPayment.js';

export const createPayment = async (institutionID: string, participationIDs: string[], paymentMethod: string) => {
  // check if participation is already paid
  const payments = await loadRawEntityDataByQuery(
    BHPayment,
    { participationIDs: { $in: participationIDs } },
    { status: 1, participationIDs: 1 },
  );
  for (const payment of payments) {
    if (payment.status === 'paid')
      throw new Error(
        'cant create payment; participations ' + payment.participationIDs.join(', ') + ' are already paid',
      );
  }

  // call payment plugin
  const paymentPlugin = getDbPluginForScope('payment', institutionID);
  return paymentPlugin.createPayment(participationIDs, paymentMethod);
};
